 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-040e9cf9":"1efc2b68","chunk-0471966a":"d28c6a84","chunk-04cf3b1f":"835b8331","chunk-0867d75f":"3e44ac6d","chunk-09cd0b70":"843fd5ac","chunk-0a1eaca9":"954bf115","chunk-0bb2fd9a":"7a5c3e5a","chunk-2d4e265b":"6e1a2a42","chunk-62379beb":"23ba6c7e","chunk-0e072455":"720b12b0","chunk-0ffeab9f":"047fa2f4","chunk-198e3942":"5374655b","chunk-1f16206c":"95333a3a","chunk-245db3ed":"186aec83","chunk-268044d4":"a018fd7e","chunk-28a9e288":"c16d17bd","chunk-29757256":"389b9aa9","chunk-2a9b8bee":"2cb0bcb7","chunk-2aed0630":"1eb494e9","chunk-2d0aa1e4":"ff81713f","chunk-2d0ac931":"17cfa0f8","chunk-2d0b20f8":"370ab3aa","chunk-2d0b9671":"e9de491c","chunk-2d0bdd44":"31936f5e","chunk-2d0be327":"96ea71ec","chunk-2d0c0883":"3b8df9dd","chunk-2d0c211b":"ba545cf5","chunk-2d0c5139":"8f481a28","chunk-2d0c557b":"77905baa","chunk-2d0c952b":"6225895b","chunk-2d0cf315":"1ef6206f","chunk-2d0e1b06":"be2de246","chunk-2d0e9079":"db44e8bb","chunk-2d0f060d":"e54a7b3f","chunk-2d0f0814":"5a97deef","chunk-2d0f14f4":"63b18db7","chunk-2d2095dd":"a4050f66","chunk-2d20fcba":"183fc301","chunk-2d213925":"cd323c9c","chunk-2d2140aa":"e9dabef6","chunk-2d217def":"b35cd03e","chunk-2d218418":"9143c193","chunk-2d21a9aa":"6003d65f","chunk-2d21e3aa":"d71a6363","chunk-2d222525":"857d844e","chunk-2d222cca":"2219326e","chunk-2d22895d":"ca2e81cc","chunk-2d2304b6":"04cf89d3","chunk-2d23721e":"db20ec86","chunk-3172533a":"ceea1cfe","chunk-32cdbffc":"678923ae","chunk-32f2d23d":"1268c824","chunk-3609acea":"513ffbd9","chunk-36da2acc":"5a36e3bb","chunk-37ff8997":"cfe6682e","chunk-3b7db6f5":"86fffeae","chunk-3bd70db3":"fb7aa885","chunk-3c03f502":"581a03ce","chunk-3d03b845":"20a12068","chunk-3ee4eca5":"d52e701e","chunk-41729f35":"3c4625c3","chunk-41c90a6b":"6dd16075","chunk-45636d0e":"7e26bdf2","chunk-45df0daa":"58f73b21","chunk-469a106c":"80c04037","chunk-4960e528":"c2bc28de","chunk-4a868a77":"f0cec892","chunk-4d93dcb2":"80af4c56","chunk-4da36b15":"30bbe83d","chunk-4f3678b7":"5882e704","chunk-55fd9bc5":"1eb902c3","chunk-57598eed":"5c8a8215","chunk-57a83ac0":"ce45c9ee","chunk-58018476":"0a49f94f","chunk-5b23fdd4":"4de319d9","chunk-6435f914":"8ccc052d","chunk-658c23da":"70e4f258","chunk-6a5dbffb":"3ef19d54","chunk-6ae2b080":"03a64324","chunk-6d44dfd7":"c8e25385","chunk-6d941db0":"211b4164","chunk-6da41528":"64534324","chunk-6da41684":"fbe985ac","chunk-793ec3d8":"ab69c1d1","chunk-7a234d26":"73dd45be","chunk-7d21e4da":"19253c3d","chunk-882768b0":"c4fdbfa9","chunk-972e2b1c":"1953438a","chunk-9f295fda":"82932192","chunk-a92a499c":"5f6cab6c","chunk-a92d751a":"1e2168d6","chunk-a9543e8c":"f20300cc","chunk-a9591d90":"aebe23c6","chunk-aaf27fd0":"0a965add","chunk-ae124cc0":"3c686e21","chunk-bd819d48":"cd284387","chunk-c377db64":"0e18c1aa","chunk-c4eb9590":"60052fc1","chunk-d6be8784":"cf3eec80","chunk-dada39de":"eb6c065a","chunk-dae3f45e":"a0972764","chunk-dd32cf7c":"d7c73ff2","chunk-de1eb938":"572cd6e7","chunk-dffd094a":"76d30f98","chunk-ea2d3954":"316e311b","chunk-efc7162e":"2a25b2af","chunk-f71781cc":"8443a7a1","chunk-f8c074fc":"c83ff14b","chunk-fd3d22ee":"8e49be43","stencil-polyfills-css-shim":"54fc0886","stencil-polyfills-dom":"a351dbf1","chunk-27918a7b":"4c2fb7cd","chunk-65458e6e":"e1370eac","chunk-93a0ae40":"5f4874d0","chunk-d3317b7e":"a9fd82dc","chunk-2d0c4a65":"99369202","chunk-2d21f28e":"c17c3517","chunk-2d22dbb6":"2495e615","chunk-2d0da519":"a87d80f0","chunk-2d0a4d7c":"252c133c","chunk-2d0cc79b":"ebefc045","chunk-2d0d0f6c":"97ef27fd","chunk-2d224c4a":"9835072f","chunk-2d230089":"06d3f17a","chunk-326a7fb9":"e9667d68","chunk-59482104":"4eb6fc3e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-040e9cf9":1,"chunk-04cf3b1f":1,"chunk-2d4e265b":1,"chunk-62379beb":1,"chunk-32f2d23d":1,"chunk-3c03f502":1,"chunk-aaf27fd0":1,"chunk-c4eb9590":1,"chunk-27918a7b":1,"chunk-65458e6e":1,"chunk-93a0ae40":1,"chunk-d3317b7e":1,"chunk-326a7fb9":1,"chunk-59482104":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-040e9cf9":"08d64ee3","chunk-0471966a":"31d6cfe0","chunk-04cf3b1f":"e608359c","chunk-0867d75f":"31d6cfe0","chunk-09cd0b70":"31d6cfe0","chunk-0a1eaca9":"31d6cfe0","chunk-0bb2fd9a":"31d6cfe0","chunk-2d4e265b":"2bfa2613","chunk-62379beb":"c3fc9357","chunk-0e072455":"31d6cfe0","chunk-0ffeab9f":"31d6cfe0","chunk-198e3942":"31d6cfe0","chunk-1f16206c":"31d6cfe0","chunk-245db3ed":"31d6cfe0","chunk-268044d4":"31d6cfe0","chunk-28a9e288":"31d6cfe0","chunk-29757256":"31d6cfe0","chunk-2a9b8bee":"31d6cfe0","chunk-2aed0630":"31d6cfe0","chunk-2d0aa1e4":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0b20f8":"31d6cfe0","chunk-2d0b9671":"31d6cfe0","chunk-2d0bdd44":"31d6cfe0","chunk-2d0be327":"31d6cfe0","chunk-2d0c0883":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0c5139":"31d6cfe0","chunk-2d0c557b":"31d6cfe0","chunk-2d0c952b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0e1b06":"31d6cfe0","chunk-2d0e9079":"31d6cfe0","chunk-2d0f060d":"31d6cfe0","chunk-2d0f0814":"31d6cfe0","chunk-2d0f14f4":"31d6cfe0","chunk-2d2095dd":"31d6cfe0","chunk-2d20fcba":"31d6cfe0","chunk-2d213925":"31d6cfe0","chunk-2d2140aa":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d218418":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21e3aa":"31d6cfe0","chunk-2d222525":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2304b6":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-3172533a":"31d6cfe0","chunk-32cdbffc":"31d6cfe0","chunk-32f2d23d":"84427e65","chunk-3609acea":"31d6cfe0","chunk-36da2acc":"31d6cfe0","chunk-37ff8997":"31d6cfe0","chunk-3b7db6f5":"31d6cfe0","chunk-3bd70db3":"31d6cfe0","chunk-3c03f502":"e580c925","chunk-3d03b845":"31d6cfe0","chunk-3ee4eca5":"31d6cfe0","chunk-41729f35":"31d6cfe0","chunk-41c90a6b":"31d6cfe0","chunk-45636d0e":"31d6cfe0","chunk-45df0daa":"31d6cfe0","chunk-469a106c":"31d6cfe0","chunk-4960e528":"31d6cfe0","chunk-4a868a77":"31d6cfe0","chunk-4d93dcb2":"31d6cfe0","chunk-4da36b15":"31d6cfe0","chunk-4f3678b7":"31d6cfe0","chunk-55fd9bc5":"31d6cfe0","chunk-57598eed":"31d6cfe0","chunk-57a83ac0":"31d6cfe0","chunk-58018476":"31d6cfe0","chunk-5b23fdd4":"31d6cfe0","chunk-6435f914":"31d6cfe0","chunk-658c23da":"31d6cfe0","chunk-6a5dbffb":"31d6cfe0","chunk-6ae2b080":"31d6cfe0","chunk-6d44dfd7":"31d6cfe0","chunk-6d941db0":"31d6cfe0","chunk-6da41528":"31d6cfe0","chunk-6da41684":"31d6cfe0","chunk-793ec3d8":"31d6cfe0","chunk-7a234d26":"31d6cfe0","chunk-7d21e4da":"31d6cfe0","chunk-882768b0":"31d6cfe0","chunk-972e2b1c":"31d6cfe0","chunk-9f295fda":"31d6cfe0","chunk-a92a499c":"31d6cfe0","chunk-a92d751a":"31d6cfe0","chunk-a9543e8c":"31d6cfe0","chunk-a9591d90":"31d6cfe0","chunk-aaf27fd0":"7d057d93","chunk-ae124cc0":"31d6cfe0","chunk-bd819d48":"31d6cfe0","chunk-c377db64":"31d6cfe0","chunk-c4eb9590":"c0bf5696","chunk-d6be8784":"31d6cfe0","chunk-dada39de":"31d6cfe0","chunk-dae3f45e":"31d6cfe0","chunk-dd32cf7c":"31d6cfe0","chunk-de1eb938":"31d6cfe0","chunk-dffd094a":"31d6cfe0","chunk-ea2d3954":"31d6cfe0","chunk-efc7162e":"31d6cfe0","chunk-f71781cc":"31d6cfe0","chunk-f8c074fc":"31d6cfe0","chunk-fd3d22ee":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-27918a7b":"0cdcf447","chunk-65458e6e":"e60e9ffb","chunk-93a0ae40":"ab89b380","chunk-d3317b7e":"a77f2e67","chunk-2d0c4a65":"31d6cfe0","chunk-2d21f28e":"31d6cfe0","chunk-2d22dbb6":"31d6cfe0","chunk-2d0da519":"31d6cfe0","chunk-2d0a4d7c":"31d6cfe0","chunk-2d0cc79b":"31d6cfe0","chunk-2d0d0f6c":"31d6cfe0","chunk-2d224c4a":"31d6cfe0","chunk-2d230089":"31d6cfe0","chunk-326a7fb9":"a0272683","chunk-59482104":"5d3737c5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
